<template>
  <el-dialog title="处理表单" :visible.sync="visible" width="680px">
    <el-form ref="form" :model="form" label-width="100px" :rules="rules">
      <el-form-item label="处理意见" prop="handler_content">
        <el-input
          type="textarea"
          :rows="4"
          class="w-96"
          placeholder="请输入处理意见"
          v-model="form.handler_content"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="处理图片" prop="files">
        <c-file-upload
          class="w-96"
          :isShowTip="false"
          :fileType="['png', 'jpg', 'jpeg']"
          v-model="form['files']"
        ></c-file-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onCancel">取 消</el-button>
      <el-button type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      form: {},
      rules: {
        handler_content: [
          {  required: true, message: '请输入处理意见', trigger: 'blur'}
        ]
      }
    };
  },
  methods: {
    onOpen(row) {
      this.form.id = row.id;
      this.visible = true;
    },
    onCancel() {
      this.form = {};
      this.$refs.form.clearValidate();
      this.visible = false;
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.onHandle();
      });
    },
    async onHandle() {
      try {
        await this.$common.http({
          url: '/api/queue/admin/handle_complaint',
          data: this.form
        });
        this.$emit('ok');
        this.onCancel();
      } catch (error) {
        
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 10px 15px 0px !important;
}
</style>
